
import { defineComponent } from 'vue';
import DefaultColors from '../../constants/Whitelabel/DefaultThemeVariables';
import icons from './icons';

export default defineComponent({
  name: 'MomntIcon',

  components: { ...icons },

  props: {
    size: { default: 24, type: [Number, String] },
    color: { default: DefaultColors.grayscaleColor1, type: String },
  },

  computed: {
  /**
   * Transforms snake_case string to camelCase component name
   */
    iconComponent(): string {
      return (this.$slots.default?.[0].text || '')?.toLowerCase()
        .replace(/(_[a-z])/g, (group) => group.toUpperCase().replace('_', ''));
    },

    style() {
      return {
        color: this.color,
      };
    },
  },
});
